export default __webpack_public_path__ + "static/media/service_indv.ed92b814.jpg";